import { z } from "zod";

export const ContactFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: "El name es requerido" })
    .min(2, { message: "El name debe tener al menos 2 caracteres" })
    .max(50, { message: "El name no puede exceder los 50 caracteres" }),
  lastName: z
    .string()
    .min(1, { message: "El lastName es requerido" })
    .min(2, { message: "El lastName debe tener al menos 2 caracteres" })
    .max(50, { message: "El lastName no puede exceder los 50 caracteres" }),
  email: z
    .string()
    .min(1, { message: "El email es requerido" })
    .email({ message: "El email no es válido" })
    .max(100, { message: "El email no puede exceder los 100 caracteres" }),
  phone: z.string().min(1, { message: "El phone es requerido" }),
  message: z
    .string()
    .min(1, { message: "El message es requerido" })
    .max(1500, { message: "El message no puede exceder los 1500 caracteres" }),
  terms: z.literal(true, {
    errorMap: () => ({ message: "Debes aceptar los términos y condiciones" }),
  }),
});

// Tipo TypeScript inferido del schema
